(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    const duration = (9 * 60 + 59) * 1000;
    // Keep the countdown only for this page load; refreshing starts a new one.
    let reservationEnd = 0;

    const tick = () => {
      const bar = drawer.querySelector('[data-ln-cart-reservation]');
      if (!bar) { reservationEnd = 0; return; }
      const timer = bar.querySelector('[data-ln-cart-timer]');
      if (!timer) return;
      if (!reservationEnd) reservationEnd = Date.now() + duration;
      const remaining = Math.max(0, Math.ceil((reservationEnd - Date.now()) / 1000));
      const minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
      const seconds = String(remaining % 60).padStart(2, '0');
      timer.textContent = `${minutes}:${seconds}`;
    };

    tick();
    window.setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ln-header-search"] && !Shopify.designMode) return;
  try {
    (() => {
    const modal = document.getElementById('search-modal');
    if (!modal) return;
    const form = modal.querySelector('[data-ln-head-form]');
    const input = modal.querySelector('[data-ln-head-input]');
    const panel = modal.querySelector('[data-ln-head-panel]');
    let timer;
    let controller;
    let requestId = 0;

    const hide = () => {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      panel.replaceChildren();
    };
    const show = (...children) => {
      panel.replaceChildren(...children);
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };
    const message = (label) => {
      const paragraph = document.createElement('p');
      paragraph.className = 'ln-head-search__message';
      paragraph.textContent = label;
      show(paragraph);
    };

    const render = (results, query) => {
      const collections = results.collections || [];
      const products = results.products || [];
      const columns = document.createElement('div');
      columns.className = 'ln-head-search__columns';
      const group = (items, label, product) => {
        const container = document.createElement('div');
        const heading = document.createElement('h3');
        container.className = 'ln-head-search__group';
        heading.textContent = label;
        container.append(heading);
        items.forEach((item) => {
          const link = document.createElement('a');
          link.className = `ln-head-search__option${product ? ' ln-head-search__option--product' : ''}`;
          link.href = item.url;
          link.setAttribute('role', 'option');
          if (product) {
            const source = item.featured_image?.url || item.image;
            if (source) {
              const image = document.createElement('img');
              const url = new URL(source, window.location.origin);
              url.searchParams.set('width', '160');
              image.className = 'ln-head-search__image';
              image.src = url.toString();
              image.alt = item.featured_image?.alt || item.title;
              image.width = 80;
              image.height = 80;
              image.loading = 'lazy';
              link.append(image);
            }
          }
          const title = document.createElement('span');
          title.textContent = item.title;
          link.append(title);
          container.append(link);
        });
        columns.append(container);
      };
      group(collections, panel.dataset.collectionsLabel, false);
      group(products, panel.dataset.productsLabel, true);
      const all = document.createElement('a');
      const destination = new URL(form.action, window.location.origin);
      destination.searchParams.set('q', query);
      destination.searchParams.set('options[prefix]', 'last');
      all.className = 'ln-head-search__view-all';
      all.href = destination.toString();
      all.setAttribute('role', 'option');
      all.textContent = panel.dataset.viewAllLabel.replaceAll('&quot;', '"').replace('{query}', query);
      if (collections.length || products.length) show(columns, all);
      else {
        const empty = document.createElement('p');
        empty.className = 'ln-head-search__message';
        empty.textContent = panel.dataset.emptyLabel;
        show(empty, all);
      }
    };

    input.addEventListener('input', () => {
      const query = input.value.trim();
      window.clearTimeout(timer);
      controller?.abort();
      const currentId = ++requestId;
      if (!query) { hide(); return; }
      message(panel.dataset.loadingLabel);
      timer = window.setTimeout(async () => {
        controller = new AbortController();
        const root = window.Shopify?.routes?.root || '/';
        const endpoint = new URL(`${root}search/suggest.json`, window.location.origin);
        endpoint.searchParams.set('q', query);
        endpoint.searchParams.set('resources[type]', 'collection,product');
        endpoint.searchParams.set('resources[limit]', '3');
        endpoint.searchParams.set('resources[limit_scope]', 'each');
        try {
          const response = await fetch(endpoint, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error(`Search failed: ${response.status}`);
          const data = await response.json();
          if (currentId === requestId && input.value.trim() === query) render(data.resources?.results || {}, query);
        } catch (error) {
          if (error.name !== 'AbortError' && currentId === requestId) message(panel.dataset.errorLabel);
        }
      }, 180);
    });
    modal.addEventListener('dialog:open', () => input.focus());
    modal.addEventListener('dialog:close', () => {
      window.clearTimeout(timer);
      controller?.abort();
      requestId += 1;
      input.value = '';
      hide();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-recommendations-louise-styles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('louise-recommendation-scrollbar')) {
    customElements.define('louise-recommendation-scrollbar', class extends HTMLElement {
      connectedCallback() {
        this.refresh = () => this.update();
        this.resizeObserver = new ResizeObserver(this.refresh);
        this.resizeObserver.observe(this);
        this.mutationObserver = new MutationObserver(this.refresh);
        this.mutationObserver.observe(this.parentElement, { childList: true, subtree: true });
        this.update();
      }
      update() {
        const scroller = this.parentElement?.querySelector('.resource-list--grid');
        if (scroller !== this.scroller) {
          if (this.scroller) {
            this.scroller.removeEventListener('scroll', this.refresh);
            this.resizeObserver.unobserve(this.scroller);
          }
          this.scroller = scroller;
          if (scroller) {
            scroller.addEventListener('scroll', this.refresh, { passive: true });
            this.resizeObserver.observe(scroller);
          }
        }
        const thumb = this.firstElementChild;
        if (!scroller || !thumb) return;
        const distance = scroller.scrollWidth - scroller.clientWidth;
        this.hidden = distance <= 1;
        const fraction = scroller.scrollWidth ? Math.min(1, scroller.clientWidth / scroller.scrollWidth) : 1;
        const progress = distance > 0 ? Math.max(0, Math.min(1, scroller.scrollLeft / distance)) : 0;
        thumb.style.width = `${fraction * 100}%`;
        thumb.style.transform = `translateX(${progress * this.clientWidth * (1 - fraction)}px)`;
      }
      disconnectedCallback() {
        this.scroller?.removeEventListener('scroll', this.refresh);
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const modal = document.getElementById('search-modal');
    if (!modal) return;
    const form = modal.querySelector('[data-ln-head-form]');
    const input = modal.querySelector('[data-ln-head-input]');
    const panel = modal.querySelector('[data-ln-head-panel]');
    let timer;
    let controller;
    let requestId = 0;

    const hide = () => {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      panel.replaceChildren();
    };
    const show = (...children) => {
      panel.replaceChildren(...children);
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };
    const message = (label) => {
      const paragraph = document.createElement('p');
      paragraph.className = 'ln-head-search__message';
      paragraph.textContent = label;
      show(paragraph);
    };

    const render = (results, query) => {
      const collections = results.collections || [];
      const products = results.products || [];
      const columns = document.createElement('div');
      columns.className = 'ln-head-search__columns';
      const group = (items, label, product) => {
        const container = document.createElement('div');
        const heading = document.createElement('h3');
        container.className = 'ln-head-search__group';
        heading.textContent = label;
        container.append(heading);
        items.forEach((item) => {
          const link = document.createElement('a');
          link.className = `ln-head-search__option${product ? ' ln-head-search__option--product' : ''}`;
          link.href = item.url;
          link.setAttribute('role', 'option');
          if (product) {
            const source = item.featured_image?.url || item.image;
            if (source) {
              const image = document.createElement('img');
              const url = new URL(source, window.location.origin);
              url.searchParams.set('width', '160');
              image.className = 'ln-head-search__image';
              image.src = url.toString();
              image.alt = item.featured_image?.alt || item.title;
              image.width = 80;
              image.height = 80;
              image.loading = 'lazy';
              link.append(image);
            }
          }
          const title = document.createElement('span');
          title.textContent = item.title;
          link.append(title);
          container.append(link);
        });
        columns.append(container);
      };
      group(collections, panel.dataset.collectionsLabel, false);
      group(products, panel.dataset.productsLabel, true);
      const all = document.createElement('a');
      const destination = new URL(form.action, window.location.origin);
      destination.searchParams.set('q', query);
      destination.searchParams.set('options[prefix]', 'last');
      all.className = 'ln-head-search__view-all';
      all.href = destination.toString();
      all.setAttribute('role', 'option');
      all.textContent = panel.dataset.viewAllLabel.replaceAll('&quot;', '"').replace('{query}', query);
      if (collections.length || products.length) show(columns, all);
      else {
        const empty = document.createElement('p');
        empty.className = 'ln-head-search__message';
        empty.textContent = panel.dataset.emptyLabel;
        show(empty, all);
      }
    };

    input.addEventListener('input', () => {
      const query = input.value.trim();
      window.clearTimeout(timer);
      controller?.abort();
      const currentId = ++requestId;
      if (!query) { hide(); return; }
      message(panel.dataset.loadingLabel);
      timer = window.setTimeout(async () => {
        controller = new AbortController();
        const root = window.Shopify?.routes?.root || '/';
        const endpoint = new URL(`${root}search/suggest.json`, window.location.origin);
        endpoint.searchParams.set('q', query);
        endpoint.searchParams.set('resources[type]', 'collection,product');
        endpoint.searchParams.set('resources[limit]', '3');
        endpoint.searchParams.set('resources[limit_scope]', 'each');
        try {
          const response = await fetch(endpoint, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error(`Search failed: ${response.status}`);
          const data = await response.json();
          if (currentId === requestId && input.value.trim() === query) render(data.resources?.results || {}, query);
        } catch (error) {
          if (error.name !== 'AbortError' && currentId === requestId) message(panel.dataset.errorLabel);
        }
      }, 180);
    });
    modal.addEventListener('dialog:open', () => input.focus());
    modal.addEventListener('dialog:close', () => {
      window.clearTimeout(timer);
      controller?.abort();
      requestId += 1;
      input.value = '';
      hide();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
